/**
 * @file 打车打车金二期接口
 * @desc 常量，包含接口路径，独立页面内公共常量
 * @author ~~
 * @data 2020/06/17
 */

const Const = {};
// 开发机环境
if (process.env.NODE_ENV === 'development') {
    Const.server = 'https://yongche.baidu.com';
    // Const.server = 'http://quyueshun.bcc-bdbl.baidu.com:8080';
}
// QA环境
else if (process.env.NODE_ENV === 'test') {
    // Const.server = 'http://quyueshun.bcc-bdbl.baidu.com:8080';
    Const.server = 'https://yongche.baidu.com';
}

// 线上环境
else {
    Const.server = 'https://yongche.baidu.com';
    // Const.server = 'http://quyueshun.bcc-bdbl.baidu.com:8080';
}

// 获取主页数据
Const.pageData = '/marketing/activity/shareactinit';
// 领取优惠券信息接口
Const.couponData = '/marketing/activity/shareactget';


Const.dataUrl = {
    getPageData: Const.server + Const.pageData,
    getCouponData: Const.server + Const.couponData
};

// 客户端信息
Const.nativeInfo = {};
export default Const;
